<app-loader [loader]="loader.count" *ngIf="loader.count > 0"></app-loader>

<app-header></app-header>

<h2 class="h2 px-2">{{'LEGAL.TITLE' | translate }}</h2>
<div class="row">
    <div class="col-sm-2 py-3"></div>
    <div class="col-sm-8 py-3">
        <h3 class="h4 px-4 reduced-h4" [innerHTML]="'LEGAL.SECTION1.HEADER' | translate "></h3>
        
        <h4 [innerHTML]="'LEGAL.SECTION1.ARTICLE1.HEADER' | translate "></h4>
        <p [innerHTML]="'LEGAL.SECTION1.ARTICLE1.P1' | translate "></p>
        
        <h4 [innerHTML]="'LEGAL.SECTION1.ARTICLE2.HEADER' | translate "></h4>
        <p [innerHTML]="'LEGAL.SECTION1.ARTICLE2.P1' | translate "></p>

        <h4 [innerHTML]="'LEGAL.SECTION1.ARTICLE3.HEADER' | translate "></h4>
        <p [innerHTML]="'LEGAL.SECTION1.ARTICLE3.P1' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION1.ARTICLE3.P2' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION1.ARTICLE3.P3' | translate "></p>

        <h3 class="h4 px-4 reduced-h4" [innerHTML]="'LEGAL.SECTION2.HEADER' | translate "></h3>

        <h4 [innerHTML]="'LEGAL.SECTION2.ARTICLE1.HEADER' | translate "></h4>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE1.P1' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE1.P2' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE1.P3' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE1.P4' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE1.P5' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE1.P6' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE1.P7' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE1.P8' | translate "></p>

        <h4 [innerHTML]="'LEGAL.SECTION2.ARTICLE2.HEADER' | translate "></h4>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE2.P1' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE2.P2' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE2.P3' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE2.P4' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE2.P5' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE2.P6' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE2.P7' | translate "></p>

        <h4 [innerHTML]="'LEGAL.SECTION2.ARTICLE3.HEADER' | translate "></h4>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE3.P1' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE3.P2' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE3.P3' | translate "></p>

        <h4 [innerHTML]="'LEGAL.SECTION2.ARTICLE4.HEADER' | translate "></h4>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE4.P1' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE4.P2' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE4.P3' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE4.P4' | translate "></p>

        <h4 [innerHTML]="'LEGAL.SECTION2.ARTICLE5.HEADER' | translate "></h4>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE5.P1' | translate "></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE5.P2' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE5.P3' | translate"></p>

        <h4 [innerHTML]="'LEGAL.SECTION2.ARTICLE6.HEADER' | translate"></h4>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE6.P1' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION2.ARTICLE6.P2' | translate"></p>

        <h3 class="h4 px-4 reduced-h4" [innerHTML]="'LEGAL.SECTION3.HEADER' | translate"></h3>

        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P1' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P2' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P3' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P4' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P5' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P6' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P7' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P8' | translate"></p>
        <p [innerHTML]="'LEGAL.SECTION3.ARTICLE1.P9' | translate"></p>
    </div>
</div>
<app-footer></app-footer>

